"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAuthToken = exports.getLoginType = exports.auth = void 0;
exports.isLogged = isLogged;
exports.getValidToken = getValidToken;
exports.getUserData = getUserData;
exports.setAuth = setAuth;
exports.logout = logout;
const config_1 = require("./config");
const exenv_1 = require("exenv");
const misc_1 = require("../utils/misc");
const channels_1 = require("../utils/channels");
const types_1 = require("../types");
const verificationUrl_1 = require("../utils/verificationUrl");
const Sentry = __importStar(require("@sentry/browser"));
// let oldUserData: any = null;
const STORAGE_TOKEN_NAME = 'auth_token';
const STORAGE_USER_INFO_NAME = 'user_info';
const STORAGE_LOGINTYPE_NAME = 'login_type';
// aggiungo le chiavi delle informazioni salvate su localstorage fra quelle che devono essere resettate in caso di
// cambio utente / logout
(0, misc_1.addUserKey)([
    STORAGE_LOGINTYPE_NAME,
    STORAGE_USER_INFO_NAME,
    STORAGE_TOKEN_NAME,
]);
function loadUserDataFromLS() {
    if (!exenv_1.canUseDOM) {
        return {};
    }
    const userDataString = localStorage.getItem(STORAGE_USER_INFO_NAME);
    if (!userDataString) {
        return {};
    }
    return JSON.parse(userDataString);
}
function getUserData() {
    return loadUserDataFromLS();
}
function getValidToken() {
    if (!exenv_1.canUseDOM) {
        return null;
    }
    return localStorage.getItem(STORAGE_TOKEN_NAME);
}
const setAuthToken = (token) => {
    if (exenv_1.canUseDOM) {
        localStorage.setItem(STORAGE_TOKEN_NAME, token);
    }
};
exports.setAuthToken = setAuthToken;
function setUserData(data) {
    if (exenv_1.canUseDOM) {
        // oldUserData = data;
        localStorage.setItem(STORAGE_USER_INFO_NAME, JSON.stringify(data.user));
    }
}
function setLoginType(loginType) {
    if (exenv_1.canUseDOM) {
        localStorage.setItem(STORAGE_LOGINTYPE_NAME, loginType);
    }
}
const getLoginType = () => {
    if (exenv_1.canUseDOM) {
        const val = localStorage.getItem(STORAGE_LOGINTYPE_NAME);
        if (!val) {
            return undefined;
        }
        else if ((0, types_1.isExtendedSocial)(val)) {
            return val;
        }
        else {
            console.error(`Corrupted localStorage key ${STORAGE_LOGINTYPE_NAME}=${val}`);
            Sentry.withScope((scope) => {
                scope.setExtra('Chiave di localStorage', STORAGE_LOGINTYPE_NAME);
                scope.setExtra('Valore di localStorage', val);
                Sentry.captureException(new Error('Corrupted localStorage key'));
            });
        }
    }
    return undefined;
};
exports.getLoginType = getLoginType;
function isLogged() {
    if (!exenv_1.canUseDOM) {
        return false;
    }
    const data = getUserData();
    const key = getValidToken();
    return Boolean(data && data.id && key);
}
function setAuth(serverAuth, loginType, isSwitch) {
    const oldUser = getUserData();
    setUserData(serverAuth.auth);
    setAuthToken(serverAuth.authorization);
    if (loginType) {
        setLoginType(loginType);
    }
    const newUser = getUserData();
    channels_1.authChannel.postMessage({
        type: 'USER_CHANGED',
        args: { oldUser, newUser, isSwitch: Boolean(isSwitch) },
    });
}
function logout() {
    const oldUser = getUserData();
    // azzero le chiavi localstorage legate all'utente
    const keysToInvalidate = JSON.parse(localStorage.getItem('@food/userKeys') || '[]');
    keysToInvalidate.forEach((key) => localStorage.removeItem(key));
    channels_1.authChannel.postMessage({
        type: 'USER_CHANGED',
        args: { newUser: null, oldUser },
    });
}
const auth = (partialConfig) => {
    const config = (0, config_1.mergeConfig)(partialConfig);
    const origin = exenv_1.canUseDOM ? window.location.origin : '';
    const redirectUrl = config.OAUTH_REDIRECT_URI;
    const SOCIAL_TYPES = {
        GOOGLE: {
            key: types_1.SOCIAL.GOOGLE,
            label: 'Sign in with Google',
            loginURL: () => `${config.GOOGLE_AUTH_URL}&redirect_uri=${redirectUrl}&state=${encodeURIComponent(JSON.stringify({ origin, provider: types_1.SOCIAL.GOOGLE }))}`,
        },
        /*FACEBOOK: {
            key: SOCIAL.FACEBOOK,
            label: 'Sign in with Facebook',
            loginURL: () => {
                return `${
                    config.FACEBOOK_AUTH_URL
                }&redirect_uri=${redirectUrl}&state=${encodeURIComponent(
                    JSON.stringify({ origin }),
                )}`;
            },
        },*/
        LINKEDIN: {
            key: types_1.SOCIAL.LINKEDIN,
            label: 'Sign in with LinkedIn',
            loginURL: () => {
                return `${config.LINKEDIN_AUTH_URL}&redirect_uri=${redirectUrl}&state=${encodeURIComponent(JSON.stringify({ origin, provider: types_1.SOCIAL.LINKEDIN }))}`;
            },
        },
        APPLE: {
            key: types_1.SOCIAL.APPLE,
            label: 'Sign in with Apple',
            loginURL: () => {
                return `${config.APPLE_AUTH_URL}&redirect_uri=${redirectUrl}&state=${encodeURIComponent(JSON.stringify({
                    origin,
                    provider: types_1.SOCIAL.APPLE,
                    sourceApp: config.TARGET_SITE,
                    redirect_uri: config.OAUTH_REDIRECT_URI,
                }))}`;
            },
        },
    };
    async function authenticate(args, tokens = {}, needsAuth = false, redirect) {
        const privacyOptIns = [];
        if (args.newsletterAccepted) {
            privacyOptIns.push('TRANSFER');
        }
        // pian piano vado a costruire il corpo della chiamata, basandomi sui parametri che ho in input
        const callBody = {
            sourceApp: args.sourceApp,
            email: args.email,
            password: args.password,
            cryptoRenewToken: args.cryptoRenewToken,
            socialType: args.socialType,
            grantToken: args.grantToken,
            options: {
                role: args.role,
                workEmail: args.workEmail,
                EmailDomain_id: args.EmailDomain_id,
                tosApproved: args.tosApproved,
                privacyOptIns,
                verificationUrl: (0, verificationUrl_1.createVerificationURL)(config.VERIFICATION_URL, redirect),
                ...(needsAuth
                    ? {
                        authToken: getValidToken()?.replace('Bearer ', ''),
                    }
                    : {}),
                redirectUri: config.OAUTH_REDIRECT_URI,
                ...tokens,
            },
        };
        const result = await (0, misc_1.httpApiCall)(callBody, config.AUTH_ENDPOINT, config.TARGET_SITE);
        return {
            success: result.success,
            payload: result,
        };
    }
    /*async function trySocialUpgrade(
        grantToken: string,
        socialType: SOCIAL,
        authToken: string,
    ): Promise<IWrappedResponse> {
        const origin = canUseDOM ? window.location.origin : '';

        const result = await httpApiCall(
            {
                sourceApp: config.TARGET_SITE,
                socialType,
                grantToken,
                options: {
                    authToken: authToken.replace('Bearer ', ''),
                    redirectUri: origin + config.OAUTH_REDIRECT_URI,
                },
            },
            config.AUTH_ENDPOINT,
            config.TARGET_SITE,
        );
        return { success: result.success === true, payload: result };
    }
    */
    return {
        SOCIAL_TYPES,
        authenticate,
    };
};
exports.auth = auth;
//# sourceMappingURL=auth.js.map